import { Component } from '@angular/core';

import { MessengerSmsComponent } from '../messages/messenger/messenger.sms.component';

@Component({
  selector   : 'wor-invoices-send-sms',
  template: require('./invoices.send-sms.component.html')
})
export class InvoicesSendSmsComponent extends MessengerSmsComponent {}
